import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import axiosInstance from '../../../constants/axiosInstance';

interface ResponseType {
  message: string;
}

const enableDisableDataLoggerRequest = async (dataLoggerId: string) => {
  const response = await axiosInstance().post(`/data-logger/deleteDataLogger`, { dataLoggerId });
  return response.data;
};

export const useEnableDisableDataLogger = () => {
  const queryClient = useQueryClient();

  return useMutation<ResponseType, Error, string>({
    mutationFn: enableDisableDataLoggerRequest,
    onSuccess: (response: ResponseType) => {
      toast.success(response?.message || 'Data Logger status updated successfully');
      queryClient.invalidateQueries({ queryKey: ['dataLoggers'] });
    },
    onError: (error: any) => {
      toast.error(error?.message || 'Failed to update Data Logger status');
    },
  });
};  
